package com.sweetlime.bingeamigo.presentation.features.xplog

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.viewmodel.koinViewModel

data class XpLogScreen(val totalXp: Int, val level: Int) : Screen {
    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel: XpLogViewModel = koinViewModel()

        LaunchedEffect(Unit) {
            viewModel.load()
        }

        XpLogContent(
            viewModel = viewModel,
            totalXp = totalXp,
            level = level,
            onBack = { navigator.pop() }
        )
    }
}